import { IAuthenticationState } from './types';

export default (): IAuthenticationState => ({
  isLoggedIn: false
});
